<template>
  <div class="members">
    <div class="banner">
      <div class="container">
        <div class="title-blue">联盟成员</div>
        <div>
          <MemberList></MemberList>
        </div>
      </div>
    </div>
    <div class="special-members">
      <div class="sub-title">能力贡献成员</div>
      <div class="list-container">
        <MembersIntroduce :data="specialMembers" :total="specialMembers.length" className="special"></MembersIntroduce>
      </div>
    </div>
    <div class="director-members">
      <div class="sub-title">理事成员</div>
      <div class="list-container">
        <MembersIntroduce :data="directorMembers" :total="directorMembers.length" className="director"></MembersIntroduce>
      </div>
    </div>
    <div class="common-members">
      <div class="sub-title">联盟成员</div>
      <div class="list-container">
        <MembersIntroduce :data="commonMembers" :total="commonMembers.length" className="common" :pageSize="6"></MembersIntroduce>
      </div>
    </div>
  </div>
</template>

<script>
import MemberList from '@/components/MemberList.vue';
import MembersIntroduce from '@/components/members-introduce.vue';
// import { specialMembers, directorMembers, commonMembers } from '@/utils/helper.js';
import { union } from '@/api/api'
import { get } from 'lodash'
export default {
  name: 'members',
  components: {
    MemberList,
    MembersIntroduce
  },
  data () {
    return {
      specialMembers: [], // 能力贡献成员
      directorMembers: [], // 理事成员
      commonMembers: [] // 联盟成员
    };
  },
  created () {
    this.getMemberList()
  },
  methods: {
    async getMemberList () {
      let { data } = await union.getMemberList()
      this.specialMembers = get(data, 'data.contribution')
      this.directorMembers = get(data, 'data.council')
      this.commonMembers = get(data, 'data.alliance')
    }

  }
};
</script>

<style lang="scss" scoped>
.members {
  .banner {
    background: url(~@/assets/images/img-bg.png) right top no-repeat #ebf1ff;
    .container {
      width: 1200px;
      margin: 0 auto;
      padding: 48px 0 82px 0;
      .title-blue {
        margin-bottom: 62px;
      }
    }
  }
  .sub-title {
    width: 1200px;
    height: 56px;
    margin: 0 auto;
    color: #ffffff;
    font-size: 24px;
    line-height: 56px;
    font-weight: bold;
    background: url(~@/assets/images/member-subtitle-bg.png) no-repeat right
      center;
  }
  .list-container {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
  }
  .special-members {
    .sub-title {
      background-color: #d8b84e;
      margin-top: -57px;
    }
  }
  .director-members {
    margin: 32px 0;
    .sub-title {
      background-color: #644df4;
    }
  }
  .common-members {
    margin-bottom: 32px;
    .sub-title {
      background-color: #0c63d7;
      // background: url(~@/assets/images/capability-nav-bg.png) no-repeat right bottom #0C63D7
    }
  }
}
</style>
